<template>
    <div class="sustainable-component competence-register">
        <!--<div class="bg-success mb-3 p-3 rounded">vue component competence-register</div>-->
        <div class="container-fluid p-0">
            <div class="row">
                <div class="col-12 col-md-4 col-xl-3 mb-4" v-for="(item, index) in competenceList" :key="index">
                    <competence-admin-competence-category v-bind:disabled="disabled" @updated="reload" :categoryname="item.Name" :competencecategoryid="item.CompetenceCategoryId" :competencelist="item.CompetenceList"></competence-admin-competence-category>
                </div>
            </div>
        </div>
        <v-snackbar :timeout="2000" v-model="showSnackBar" color="success">
            {{snackbarMessage}}
        </v-snackbar>
        <v-snackbar :timeout="2000" v-model="showErrorMessageSnackBar" color="error">
            {{errorMessage}}
        </v-snackbar>
        <common-spinner v-bind:loading="loading > 0"></common-spinner>
    </div>
</template>


<script>

    import CompetenceAdminCompetenceCategory from "./competence-admin-competence-category.vue";
    import CompetenceService from "../../Services/CompetenceService";
    import CommonSpinner from '../../common/common-spinner.vue'

    export default {

        name: 'competence-register',
        props: {
            model: Object,
            disabled: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        components: {
            CompetenceAdminCompetenceCategory,
            CommonSpinner
        },
        methods: {
            async reload() {
                this.loading++;
                try {
                    var competenceList = await CompetenceService.getCompetenceByCompany();
                    this.competenceList = competenceList;
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            displaySnackBar(message) {
                this.snackbarMessage = message;
                this.showSnackBar = true;
            },
            displayErrorSnackBar(message) {
                this.errorMessage = message;
                this.showErrorMessageSnackBar = true;
            },
        },

        data() {
            return {
                competenceList:[],
                internalModel: {
                    JobPositions: [],
                    BlockGrades: [],
                    WageFactorGrades: [],
                    WageFactors: [],
                },
                newWindow: {},
                loading: 0,
                showSnackBar: false,
                snackbarMessage: null,
                showErrorMessageSnackBar: false,
                errorMessage: null,
            };
        },
        watch: {
            //selectedPosition1: function(newVal){
            //    this.getWorkTasks(newVal);
            //    this.getWorkBlocks(newVal);
            //},

        },
        mounted() {
            this.internalModel = this.model;
            this.reload();
        },
        setup () {
            //const workDialog = ref()
            //return { workDialog }
            return {};
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
